import { DomainBranding, DomainReference } from '@rygen/rygen-ui/model';

import { EmbeddableLocation } from './EmbeddableLocation';
import { QuickSearchDate } from './QuickSearchDate';
import { ReferenceNumber } from './ReferenceNumber';

export class QuickSearchResult {
  id?: number;
  type?: string;
  status?: string;
  origin?: EmbeddableLocation;
  destination?: EmbeddableLocation;
  firstDate?: QuickSearchDate;
  secondDate?: QuickSearchDate;
  matchedReferenceNumbers?: ReferenceNumber[] = [];
  match?: string[] = [];
  matchedTags?: string[] = [];
  searchType = 'QuickSearch' as const;
  domainReference?: DomainReference;
  domainBranding?: DomainBranding;

  constructor(opts?: Partial<QuickSearchResult>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.type != null) {
      this.type = opts.type;
    }
    if (opts?.status != null) {
      this.status = opts.status;
    }
    if (opts?.origin != null) {
      this.origin = new EmbeddableLocation(opts.origin);
    }
    if (opts?.destination != null) {
      this.destination = new EmbeddableLocation(opts.destination);
    }
    if (opts?.firstDate != null) {
      this.firstDate = new QuickSearchDate(opts.firstDate);
    }
    if (opts?.secondDate != null) {
      this.secondDate = new QuickSearchDate(opts.secondDate);
    }
    if (opts?.matchedReferenceNumbers != null) {
      this.matchedReferenceNumbers = opts.matchedReferenceNumbers.map(
        (val) => new ReferenceNumber(val),
      );
    }
    if (opts?.match != null) {
      this.match = opts.match;
    }
    if (opts?.matchedTags != null) {
      this.matchedTags = opts.matchedTags;
    }
    if (opts?.domainReference != null) {
      this.domainReference = new DomainReference(opts.domainReference);
    }
    if (opts?.domainBranding != null) {
      this.domainBranding = new DomainBranding(opts.domainBranding);
    }
  }
}
